enum MeetingStatus {
  Loading,
  Succeeded,
  Failed
}

export default MeetingStatus;
